module.exports = __webpack_public_path__ + "static/media/vagn.c99b67fe.png";